import { render } from "./ProcessingV2.vue?vue&type=template&id=a9379e08&scoped=true"
import script from "./ProcessingV2.vue?vue&type=script&lang=js"
export * from "./ProcessingV2.vue?vue&type=script&lang=js"

import "./ProcessingV2.vue?vue&type=style&index=0&id=a9379e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9379e08"]])

export default __exports__